var map = {
	"./bmr-demon.png": 387,
	"./bmr-minion.png": 9764,
	"./bmr-outsider.png": 3396,
	"./bmr-townsfolk.png": 4174,
	"./bmr.png": 4085,
	"./custom.png": 5592,
	"./luf.png": 8142,
	"./snv-demon.png": 2867,
	"./snv-minion.png": 3571,
	"./snv-outsider.png": 3429,
	"./snv-townsfolk.png": 1822,
	"./snv.png": 9857,
	"./tb-demon.png": 6737,
	"./tb-minion.png": 972,
	"./tb-outsider.png": 2338,
	"./tb-townsfolk.png": 9600,
	"./tb.png": 6827
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3821;